<template>
  <div class="lxm-activity-table box is-marginless">
    <table class="lxm-activity-table__table">
      <thead>
        <tr>
          <template v-for="d in heads">
            <th :style="d.style" v-html="html(d)"></th>
          </template>
        </tr>
      </thead>
      <tr v-for="(row, index) in rows"
          :key="index"
          @click="rowClicked(index)">
        <template v-for="d in row">
          <td v-if="d.isCanceled">
            <span>已取消</span>
          </td>
          <td v-else-if="d.isSignButton">
            <a class="button is-primary"
               :class="{ 'is-loading': d.loading }"
               @click.stop="signin(index)">
               签到
            </a>
          </td>
          <td v-else-if="d.canSignout">
            <a class="button is-primary"
               :class="{ 'is-loading': d.loading }"
               @click="signout(index)">
               签退
            </a>
          </td>
          <td v-else-if="d.isSigned">
            <span>已签到</span>
          </td>
          <td v-else v-html="html(d)" style="overflow-wrap: anywhere"></td>
        </template>
        <td>
          <div class="lxm-table__icon lxm-table__icon--right-arrow"></div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="stylus">
  @import '../../styles/index.styl'
  table-border-width = 1px
  .lxm-activity-table
    width: 100%
    &.box
      padding: 0 spacing
      background: transparent
      overflow: hidden // 圆角
  .lxm-activity-table__table
    margin-bottom: 0
    background-color: transparent
    border-collapse: separate
    tr:hover
      background-color: transparent
    tr:last-child
      td
        border: none
    th, td
      vertical-align: middle
      border: table-border-width dashed white-line
      border-width: 0 0 table-border-width
      color: grey-dark
      background-color: white
      font-weight: normal
      font-size: size-big
      width: 60%
      padding: spacing 0
      text-align: center
    th:first-child, td:first-child
      text-align: left
      width: 20%
    th:last-child
      padding-right: spacing-small
      text-align: right
      width:20%
    td:first-child
      width: 20%
    td:last-child
      padding: 0 0
      width: 20%
      text-align: right
      .button
        padding: siz(5) spacing
        color: white
        background-color: #ff5348
        border: none
        border-radius: radius
        font-size: size
      span
        padding-right: spacing-small
        color: #ff5348
        font-size: size
    thead
      th, td
        border-width: 0 0 table-border-width
        color: grey-dark
</style>

<script>
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      heads: Array,
      rows: Array,
      tos: Array,
      activityId: String
    },
    data () {
      return {
        expanded: true
      }
    },
    computed: {
      list () {
        return this.$store.state.activity.feedback.signupList
      }
    },
    methods: {
      rowClicked (index) {
        if (this.tos && this.tos[index]) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(this.tos[index])
        }
      },
      tdStyle (d) {
        return d ? d.style : {}
      },
      html (data) {
        if (data) {
          switch (data.type) {
            case 'img':
              return `<img src="${data.value}" />`
            case 'text':
            case 'html':
              return data.value
            case 'icon':
              switch (data.value) {
                case '>':
                  return `<div class="lxm-table__icon lxm-table__icon--right-arrow"></div>`
                case 'v':
                  if (this.expanded) {
                    return `<div class="lxm-table__icon lxm-table__icon--down-arrow" style="transform: rotateX(180deg);"></div>`
                  } else {
                    return `<div class="lxm-table__icon lxm-table__icon--down-arrow"></div>`
                  }
                default:
                  return `<div class="lxm-table__icon lxm-table__icon--ellipsis"></div>`
              }
            default:
              return data
          }
        } else {
          return ''
        }
      },
      signin (index) {
        // 获取 ticketNo（在 rows 的第三列）
        const rowData = this.rows[index]
        const signInData = rowData.find(d => d && d.ticketNo !== undefined)
        const ticketNo = signInData ? signInData.ticketNo : ''
        // 跳转到 detail 页面，并传递 activityId 和 ticketNo
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push({
          path: '/main/activity/detail',
          query: {
            activityId: this.activityId,
            ticketNo: ticketNo
          }
        })
      },
      signout (index) {
        const id = this.list[index].id
        this.$store.dispatch(aTypes.ACTIVITY_POST_SIGNOUT, {
          activityId: this.activityId,
          signUpId: id,
          index: index
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmActivityTable.vue?30c54976